import { relationGroupsConstants } from '../../_constants';
import { relationGroupsService } from '../../_services';
import { relationGroupsTableActions } from './relationGroupsTable.actions';

export const editRelationAction = {
    editRelation
};

function editRelation(id, data) {
    return dispatch => {
        dispatch(request(data));
        relationGroupsService.editRelation(id, data)
            .then(
                relation => {
                    dispatch(relationGroupsTableActions.getRelationGroups())
                    dispatch(success(relation));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(data) { return { type: relationGroupsConstants.REQUEST_EDIT_RELATION, data } }
    function success(relation) { return { type: relationGroupsConstants.RECEIVE_EDIT_RELATION, relation } }
    function failure(error) { return { type: relationGroupsConstants.EDIT_RELATION_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/relationGroups/editRelation.action.js